// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Guest_contact-container__IMg2y {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--sp-10) var(--sp-5) var(--sp-16);
  font-family: var(--font-sans);
  position: relative;
  width: 100%;
}

.Guest_contact-title__wtfFw {
  position: relative;
  text-align: center;
  font-size: 44px;
  font-weight: var(--fw-bold);
  letter-spacing: -0.02em;
  margin: 0 auto var(--sp-12);
  padding: var(--sp-10) var(--sp-5);
  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 60%, #F472B6 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  line-height: 1.1;
}
.Guest_contact-title__wtfFw::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: var(--sp-6);
  transform: translateX(-50%);
  width: 72px;
  height: 4px;
  border-radius: var(--radius-pill);
  background: linear-gradient(90deg, #0EA5E9, #8B5CF6);
  -webkit-text-fill-color: initial;
}

.Guest_guide-container__j-vFI {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 var(--sp-5);
}

.Guest_guide-content__GDLqG {
  padding: var(--sp-8);
  background-color: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-sm);
}
.Guest_guide-content__GDLqG h1, .Guest_guide-content__GDLqG h2 {
  color: var(--color-text);
  letter-spacing: -0.01em;
}
.Guest_guide-content__GDLqG h1 {
  font-size: 28px;
  margin: 0 0 var(--sp-5);
  font-weight: var(--fw-bold);
}
.Guest_guide-content__GDLqG h2 {
  font-size: 22px;
  margin: 0 0 var(--sp-3);
  font-weight: var(--fw-bold);
}

.Guest_intro-text__EO6af {
  font-size: 17px !important;
  line-height: 1.7 !important;
  margin: 0 0 var(--sp-5) !important;
  color: var(--color-text-muted);
}

.Guest_feature-section__TgX7P {
  position: relative;
  margin: var(--sp-6) 0 !important;
  padding: var(--sp-6) var(--sp-6) var(--sp-6) var(--sp-8);
  background: linear-gradient(135deg, rgba(14, 165, 233, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.Guest_feature-section__TgX7P::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #0EA5E9 0%, #8B5CF6 100%);
}
.Guest_feature-section__TgX7P h2 {
  color: var(--color-text);
  font-size: 20px;
  margin: 0 0 var(--sp-3);
  font-weight: var(--fw-bold);
  letter-spacing: -0.01em;
}
.Guest_feature-section__TgX7P p {
  font-size: 15px !important;
  line-height: 1.65 !important;
  color: var(--color-text-muted) !important;
  margin: 0;
}

.Guest_featureTitle__sAy1k {
  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.Guest_conclusion__Rj0D1 {
  margin-top: var(--sp-8) !important;
  padding: var(--sp-6) var(--sp-8) !important;
  background: linear-gradient(135deg, rgba(14, 165, 233, 0.06) 0%, rgba(139, 92, 246, 0.06) 100%);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  color: var(--color-text);
  text-align: center;
  box-shadow: var(--shadow-sm);
}
.Guest_conclusion__Rj0D1 p {
  font-size: 15px !important;
  line-height: 1.7 !important;
  font-weight: var(--fw-medium) !important;
  color: var(--color-text-muted) !important;
  margin: 0;
}

.Guest_page-title__f1ptQ {
  display: flex;
  font-size: 22px;
  font-weight: var(--fw-bold);
  color: var(--color-text);
  padding-left: var(--sp-12);
}

.Guest_guide-title__N2VBL {
  text-align: center;
  font-size: 32px;
  font-weight: var(--fw-bold);
  color: var(--color-text);
  margin-bottom: var(--sp-8);
}

.Guest_p-16__tYKQ\\+ {
  padding: var(--sp-4);
}

.Guest_highlight__Mx0Yn {
  color: var(--color-danger);
  font-weight: var(--fw-semibold);
}`, "",{"version":3,"sources":["webpack://./src/pages/Guest/Guest.module.scss"],"names":[],"mappings":"AAQA;EACE,iBAAA;EACA,cAAA;EACA,8CAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;AAPF;;AAWA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,0EAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AARF;AAUE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAA;EACA,oDAAA;EACA,gCAAA;AARJ;;AAgBA;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,iCAAA;EACA,qCAAA;EACA,+BAAA;EACA,4BAAA;AAbF;AAiBI;EACE,wBAAA;EACA,uBAAA;AAfN;AAiBI;EACE,eAAA;EACA,uBAAA;EACA,2BAAA;AAfN;AAiBI;EACE,eAAA;EACA,uBAAA;EACA,2BAAA;AAfN;;AAoBA;EACE,0BAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;AAjBF;;AAqBA;EACE,kBAAA;EACA,gCAAA;EACA,wDAAA;EACA,+FAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;AAlBF;AAoBE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,6DAAA;AAlBJ;AAqBE;EACE,wBAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,uBAAA;AAnBJ;AAsBE;EACE,0BAAA;EACA,4BAAA;EACA,yCAAA;EACA,SAAA;AApBJ;;AAwBA;EAIE,6DAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;AAxBF;;AA2BA;EAIE,kCAAA;EACA,2CAAA;EACA,+FAAA;EACA,qCAAA;EACA,+BAAA;EACA,wBAAA;EACA,kBAAA;EACA,4BAAA;AA3BF;AA6BE;EACE,0BAAA;EACA,2BAAA;EACA,wCAAA;EACA,yCAAA;EACA,SAAA;AA3BJ;;AAiCA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,wBAAA;EACA,0BAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,wBAAA;EACA,0BAAA;AA9BF;;AAiCA;EAAQ,oBAAA;AA7BR;;AA+BA;EACE,0BAAA;EACA,+BAAA;AA5BF","sourcesContent":["// Guest pages — Introduce (/introduce → \"Overview\").\n//\n// contact-container / contact-title 이라는 이름은 ContactUS 화면과 함께 쓰던\n// 흔적입니다. 그 화면은 헬프데스크로 대체되어 삭제됐고, 지금은 Introduce 만\n// 이 클래스들을 씁니다. 이름을 바꾸려면 Introduce.js 와 함께 고쳐 주세요.\n//\n// Pretendard @font-face moved to src/styles/global.scss.\n\n.contact-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: var(--sp-10) var(--sp-5) var(--sp-16);\n  font-family: var(--font-sans);\n  position: relative;\n  width: 100%;\n}\n\n// ---------- Page title (Overview) ----------\n.contact-title {\n  position: relative;\n  text-align: center;\n  font-size: 44px;\n  font-weight: var(--fw-bold);\n  letter-spacing: -0.02em;\n  margin: 0 auto var(--sp-12);\n  padding: var(--sp-10) var(--sp-5);\n  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 60%, #F472B6 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n  line-height: 1.1;\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: 50%;\n    bottom: var(--sp-6);\n    transform: translateX(-50%);\n    width: 72px;\n    height: 4px;\n    border-radius: var(--radius-pill);\n    background: linear-gradient(90deg, #0EA5E9, #8B5CF6);\n    -webkit-text-fill-color: initial;\n  }\n}\n\n\n// ====================================================================\n// Introduce (\"Overview\")\n// ====================================================================\n.guide-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 0 var(--sp-5);\n}\n\n.guide-content {\n  padding: var(--sp-8);\n  background-color: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-sm);\n\n  // Cascade for any nested h1/h2 in case marked-up content uses raw tags.\n  :global {\n    h1, h2 {\n      color: var(--color-text);\n      letter-spacing: -0.01em;\n    }\n    h1 {\n      font-size: 28px;\n      margin: 0 0 var(--sp-5);\n      font-weight: var(--fw-bold);\n    }\n    h2 {\n      font-size: 22px;\n      margin: 0 0 var(--sp-3);\n      font-weight: var(--fw-bold);\n    }\n  }\n}\n\n.intro-text {\n  font-size: 17px !important;\n  line-height: 1.7 !important;\n  margin: 0 0 var(--sp-5) !important;\n  color: var(--color-text-muted);\n}\n\n// Feature card on the Introduce page\n.feature-section {\n  position: relative;\n  margin: var(--sp-6) 0 !important;\n  padding: var(--sp-6) var(--sp-6) var(--sp-6) var(--sp-8);\n  background: linear-gradient(135deg, rgba(14, 165, 233, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n    background: linear-gradient(180deg, #0EA5E9 0%, #8B5CF6 100%);\n  }\n\n  h2 {\n    color: var(--color-text);\n    font-size: 20px;\n    margin: 0 0 var(--sp-3);\n    font-weight: var(--fw-bold);\n    letter-spacing: -0.01em;\n  }\n\n  p {\n    font-size: 15px !important;\n    line-height: 1.65 !important;\n    color: var(--color-text-muted) !important;\n    margin: 0;\n  }\n}\n\n.featureTitle {\n  // Direct className target on the first feature h2 in Introduce.js\n  // (uses styles.featureTitle). The .feature-section h2 selector already styles it,\n  // but this gives a tiny accent in case the parent rule changes.\n  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n}\n\n.conclusion {\n  // Light tone — matches the rest of the Overview page and the new white shell.\n  // Soft brand-tinted gradient + thin border, so it still reads as a distinct\n  // \"closing\" block without the previous slate-900 slab.\n  margin-top: var(--sp-8) !important;\n  padding: var(--sp-6) var(--sp-8) !important;\n  background: linear-gradient(135deg, rgba(14, 165, 233, 0.06) 0%, rgba(139, 92, 246, 0.06) 100%);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-xl);\n  color: var(--color-text);\n  text-align: center;\n  box-shadow: var(--shadow-sm);\n\n  p {\n    font-size: 15px !important;\n    line-height: 1.7 !important;\n    font-weight: var(--fw-medium) !important;\n    color: var(--color-text-muted) !important;\n    margin: 0;\n  }\n}\n\n// ---------- Legacy classes left for any stray references ----------\n// (kept minimal in case other components reach into this module)\n.page-title {\n  display: flex;\n  font-size: 22px;\n  font-weight: var(--fw-bold);\n  color: var(--color-text);\n  padding-left: var(--sp-12);\n}\n\n.guide-title {\n  text-align: center;\n  font-size: 32px;\n  font-weight: var(--fw-bold);\n  color: var(--color-text);\n  margin-bottom: var(--sp-8);\n}\n\n.p-16 { padding: var(--sp-4); }\n\n.highlight {\n  color: var(--color-danger);\n  font-weight: var(--fw-semibold);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contact-container": `Guest_contact-container__IMg2y`,
	"contact-title": `Guest_contact-title__wtfFw`,
	"guide-container": `Guest_guide-container__j-vFI`,
	"guide-content": `Guest_guide-content__GDLqG`,
	"intro-text": `Guest_intro-text__EO6af`,
	"feature-section": `Guest_feature-section__TgX7P`,
	"featureTitle": `Guest_featureTitle__sAy1k`,
	"conclusion": `Guest_conclusion__Rj0D1`,
	"page-title": `Guest_page-title__f1ptQ`,
	"guide-title": `Guest_guide-title__N2VBL`,
	"p-16": `Guest_p-16__tYKQ+`,
	"highlight": `Guest_highlight__Mx0Yn`
};
export default ___CSS_LOADER_EXPORT___;
